import {
  catalogFungicides,
  catalogNematicides,
  catalogVarieties,
} from '@/modules/catalog/mock/catalogSeeds.js'
import { mockFlag } from '@/utils/mock'
import { APIFailureWrapper } from '@/utils/mock'
import {
  fungicideFilters,
  nematicideFilters,
  varietyFilters,
} from '@/modules/catalog/mock/catalogFilterSeeds'

const catalogRoutes = [
  mockFlag(
    {
      method: 'get',
      url: '/catalogs',
      result: ({ queryParams }) => {
        const products = {}
        const limit = Number(queryParams.limit)
        const offset = Number(queryParams.offset) - 1

        const startIndex = offset * limit
        const endIndex = startIndex + limit

        if (queryParams.category === 'fungicide') {
          products.list = catalogFungicides.slice(startIndex, endIndex)
          products.total = catalogFungicides.length
        } else if (queryParams.category === 'variety') {
          products.list = catalogVarieties.slice(startIndex, endIndex)
          products.total = catalogVarieties.length
        } else if (queryParams.category === 'nematicide') {
          products.list = catalogNematicides.slice(startIndex, endIndex)
          products.total = catalogNematicides.length
        }
        return APIFailureWrapper({
          content: products,
          errorMessage: 'Erro ao buscar items do catálogo',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/catalogs/:category/filters',
      result: ({ params }) => {
        let filters = {}
        if (params.category === 'fungicide') {
          filters = fungicideFilters
        } else if (params.category === 'variety') {
          filters = varietyFilters
        } else if (params.category === 'nematicide') {
          filters = nematicideFilters
        }
        return APIFailureWrapper({
          content: filters,
          errorMessage: 'Erro ao buscar filtros por categoria do catálogo',
        })
      },
    },
    'on'
  ),
]

export { catalogRoutes }
